document.addEventListener("DOMContentLoaded", function () {

    const slider = document.querySelector(".testimonialSwiper");

    if (!slider) return;

    // Initialize only if Swiper exists
    if (typeof Swiper === "undefined") {
        console.error("Swiper library is not loaded.");
        return;
    }

    new Swiper(".testimonialSwiper", {

        slidesPerView: 3,
        spaceBetween: 30,
        loop: true,
        speed: 700,

        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
        },

        pagination: {
            el: ".swiper-pagination",
            clickable: true
        },

        breakpoints: {

            0: {
                slidesPerView: 1
            },

            768: {
                slidesPerView: 2
            },

            1024: {
                slidesPerView: 3
            }

        }

    });

});